/**
 * @typedef {import('node_modules/vuetify/types/index').DataTableHeader} DataTableHeader
 */

/** @type {DataTableHeader[]} */
const tableHeaders = [
  {
    text: 'Project',
    value: 'project_title',
    class: 'timesheet-table__header-title',
  },
  {
    text: 'Task',
    value: 'task_type_title',
    class: 'timesheet-table__header-type',
  },
  {
    text: 'Position',
    value: 'position_name',
    class: 'timesheet-table__header-position',
    width: '150px',
  },
  {
    text: 'Time',
    value: 'minutes',
    class: 'timesheet-table__header-time',
  },
  {
    text: 'Overtime',
    value: 'overtime',
    class: 'timesheet-table__header-overtime',
  },
  {
    text: 'Overtime Payable',
    value: 'is_overtime_payable',
    class: 'timesheet-table__header-overtime-payable',
  },
  {
    text: 'Overtime Multiplier',
    value: 'overtime_multiplier',
    class: 'timesheet-table__header-overtime-multiplier',
  },
  {
    text: 'Billable',
    value: 'is_billable',
    class: 'timesheet-table__header-billable',
  },
  {
    text: 'Description',
    value: 'description',
    class: 'timesheet-table__header-description',
  },
  {
    text: 'Date',
    value: 'date',
    class: 'timesheet-table__header-date',
  },
  {
    text: 'Status',
    value: 'status',
    class: 'timesheet-table__header-status',
  },
  {
    text: '',
    value: '',
    class: 'timesheet-table__header-buttons',
  },
];

const tableHeadersForSystemRoles = [
  'is_overtime_payable',
  'overtime_multiplier',
  'is_billable',
];

export { tableHeaders, tableHeadersForSystemRoles };
